<p class="intro" [innerHTML]="'parameters/alcmeon-ai/setup/intro' | translate"></p>

<form [formGroup]="form">
  <div class="search-save">
    <app-search-bar [searchKey]="'parameters/alcmeon-ai/setup/search-placeholder'"></app-search-bar>
    <button mat-raised-button color="primary" (click)="save()" translate="save" [disabled]="form.pristine"></button>
  </div>
  <app-table [config]="config" [filters]="filters"></app-table>
</form>

<ng-template #aiAgentSelect let-control="control">
  <app-select
    [appearance]="'outline'"
    [control]="control"
    [enableTypeahead]="false"
    [formFieldClass]="'no-vertical-padding'"
    [items]="aiAgentsChoices"
    [labelKey]="'parameters/alcmeon-ai/setup/table/col/ai-agent'"></app-select>
</ng-template>

<ng-template #displayModesSelect let-control="control">
  <app-select
    [appearance]="'outline'"
    [control]="control"
    [enableTypeahead]="false"
    [formFieldClass]="'no-vertical-padding'"
    [items]="displayModesChoices"
    [labelKey]="'parameters/alcmeon-ai/setup/table/col/display-mode'"></app-select>
</ng-template>
